module.exports = __webpack_public_path__ + "img/dollar_icon.11eeb3c4.svg";